import { Toolbar } from '@box/blueprint-web';
import {
  TextBold,
  TextItalics,
  TextStrikethrough,
  TextUnderline,
} from '@box/blueprint-web-assets/icons/Fill';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { FONT_STYLES } from '../../../constants';
import messages from '../../../messages';

type FontStyleListProps = {
  editor: Editor;
};

export const FontStyleList = ({ editor }: FontStyleListProps) => {
  const intl = useIntl();

  const toggleItemProps = {
    [FONT_STYLES.BOLD]: {
      icon: TextBold,
      value: FONT_STYLES.BOLD,
      ariaLabel: intl.formatMessage(messages.editorToolbarBoldAriaLabel),
      onClick: () => editor.chain().focus().toggleBold().run(),
    },
    [FONT_STYLES.ITALIC]: {
      icon: TextItalics,
      value: FONT_STYLES.ITALIC,
      ariaLabel: intl.formatMessage(messages.editorToolbarItalicAriaLabel),
      onClick: () => editor.chain().focus().toggleItalic().run(),
    },
    [FONT_STYLES.UNDERLINE]: {
      icon: TextUnderline,
      value: FONT_STYLES.UNDERLINE,
      ariaLabel: intl.formatMessage(messages.editorToolbarUnderlineAriaLabel),
      onClick: () => editor.chain().focus().toggleUnderline().run(),
    },
    [FONT_STYLES.STRIKETHROUGH]: {
      icon: TextStrikethrough,
      value: FONT_STYLES.STRIKETHROUGH,
      ariaLabel: intl.formatMessage(
        messages.editorToolbarStrikethroughAriaLabel,
      ),
      onClick: () => editor.chain().focus().toggleStrike().run(),
    },
  };

  return (
    <Toolbar.ToggleGroup type="multiple">
      {Object.entries(toggleItemProps).map(([key, itemProps]) => (
        <Toolbar.ToggleItem
          key={key}
          aria-label={itemProps.ariaLabel}
          icon={itemProps.icon}
          value={itemProps.value}
          onClick={itemProps.onClick}
        />
      ))}
    </Toolbar.ToggleGroup>
  );
};
